module.exports.prettyUrl = (url) => {
    let validation = false;

    if (url.includes('https://')) {
        validation = true;
    }
    if (url.includes('http://')) {
        validation = true;
    }

    if (validation === false) {
        url = `http://${url}`;
    }

    return url;
}